import { Formik, Form, ErrorMessage } from "formik";
import { Input } from "@mui/base/Input";
import CustomButton from "components/Button/Button";
import * as Yup from "yup";
import { EMAIL_REGEXP } from "constants/validation";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useAppDispatch, useAppSelector } from "store";
import { useCallback } from "react";
import { exchangeActions } from "../../../store/reducers/exchange";
import { resetPassword } from "store/reducers/signIn";
import { signInActions } from "store/reducers/signIn";
import CommonPopup from "components/PopUps/CommonPopup/CommonPopup";
import DoneForgotPassword from "../DoneForgotPassword/DoneForgotPassword";

const validationSchema = () => {
  return Yup.object().shape({
    email: Yup.string()
      .required("Email is required")
      .matches(EMAIL_REGEXP, "Email is incorrect"),
  });
};
const ForgotPassword = () => {
  const dispatch = useAppDispatch();

  const openSignIn = useCallback(() => {
    dispatch(exchangeActions.setComponentsName("SignIn"));
  }, [dispatch]);
  const { isOpenPopup, isResetPasswordSuccess } = useAppSelector(
    (state) => state.signIn
  );

  const resetPasswordAction = useCallback(
    (email: string) => {
      dispatch(resetPassword({ email: email }));
    },
    [dispatch]
  );
  const handleClosePopup = useCallback(() => {
    dispatch(signInActions.setIsOpenPopup(false));
    openSignIn();
  }, [dispatch]);
  return (
    <>
      {isOpenPopup ? (
        isResetPasswordSuccess ? (
          <DoneForgotPassword onClick={handleClosePopup} />
        ) : (
          <CommonPopup
            onClick={handleClosePopup}
            header={"Password Reset Failed"}
            desc={
              "We couldn't reset your password. Please try again or contact support if the issue persists."
            }
          />
        )
      ) : (
        <div className="signin-container">
          <div className="signin-title">Forgot password?</div>
          <div className="signin-subtitle">
            Enter your details below to request an PayPilot OTC account password
            reset
          </div>

          <Formik
            initialValues={{ email: "" }}
            validationSchema={validationSchema}
            onSubmit={(values) => {}}
          >
            {({
              values,
              errors,
              touched,
              isSubmitting,
              isValid,
              handleChange,
              handleBlur,
              setFieldValue,
            }) => {
              return (
                <Form className="signin-form">
                  <Input
                    name="email"
                    type="text"
                    placeholder="Email"
                    id="email"
                    autoComplete="on"
                    onChange={handleChange}
                    onBlur={(e) => {
                      handleBlur(e);
                      setFieldValue("email", e.target.value.trim());
                    }}
                    className={
                      touched.email && errors.email
                        ? "error-field signin-input"
                        : "signin-input"
                    }
                  />
                  <ErrorMessage
                    name={"email"}
                    render={(msg) => (
                      <div className="error-message">
                        <InfoOutlinedIcon />
                        {msg}
                      </div>
                    )}
                  />
                  <CustomButton
                    type="submit"
                    btnName="Submit"
                    className="blue-btn submit-btn"
                    onClick={() => resetPasswordAction(values.email)}
                    disabled={!isValid || !values.email.length}
                  />
                  <CustomButton
                    type="button"
                    btnName="Back"
                    className="grey-btn"
                    disabled={false}
                    onClick={() => openSignIn()}
                  />
                </Form>
              );
            }}
          </Formik>
        </div>
      )}
    </>
  );
};
export default ForgotPassword;
